import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { Admin } from './components/Admin';

const isAdmin = window.location.pathname.replace(/\/+$/, '') === '/admin';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {isAdmin ? <Admin /> : <App />}
  </StrictMode>
);
